import classnames from 'classnames'

import '@hotmart/cosmos/dist/loading'
import '@hotmart/cosmos/dist/styles/utilities/flex/flex.css'
import '@hotmart/cosmos/dist/styles/utilities/display/display.css'
import '@hotmart/cosmos/dist/styles/utilities/position.css'
import '@hotmart/cosmos/dist/styles/utilities/sizing/sizing.css'

interface Props {
  className?: string,
  full?: boolean
}

const Loading = ({ full, className }: Props) => {
  const classes = classnames('hot-loading', {
    '_d-flex _align-items-center _position-absolute _justify-content-center _w-full _h-full': full
  })

  return (
    <div className={classes} data-test="loading">
      <hot-loading class={classnames(className)} />
    </div>
  )
}

export default Loading
